export const getPaginationRange = (currentPage: number, totalPages: number): (number | string)[] => {
  if (totalPages <= 1) return [1];

  const pages = new Set<number>();
  
  // Always include first page
  pages.add(1);
  
  // Always include last page
  pages.add(totalPages);
  
  // Include current page
  pages.add(currentPage);
  
  // Include adjacent pages
  if (currentPage - 1 > 1) pages.add(currentPage - 1);
  if (currentPage + 1 < totalPages) pages.add(currentPage + 1);
  
  // Boundary symmetry:
  // If current page is the first page, include current + 2
  if (currentPage === 1 && totalPages >= 3) {
    pages.add(3);
  }
  // If current page is the last page, include current - 2
  if (currentPage === totalPages && totalPages - 2 > 1) {
    pages.add(totalPages - 2);
  }
  
  const sortedPages = Array.from(pages).sort((a, b) => a - b);
  const result: (number | string)[] = [];
  
  for (let i = 0; i < sortedPages.length; i++) {
    const current = sortedPages[i];
    if (i === 0) {
      result.push(current);
    } else {
      const prev = sortedPages[i - 1];
      const diff = current - prev;
      if (diff > 1) {
        result.push("...");
      }
      result.push(current);
    }
  }
  return result;
};
